<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('TerminalCommand.terminalType')">
                    <el-select
                      v-model="formInline.typeId"
                      :placeholder="$t('common.all')"
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in typeList"
                        :key="item.id"
                        :label="item.terminalType"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('TerminalFile.firmwareVersion')">
                    <el-select
                      v-model="formInline.isFirmwareVersion"
                      style="width: 120px"
                      :placeholder="$t('common.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.firmwareVersion"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('TerminalFile.simIccicd')">
                    <el-input
                      size="mini"
                      v-model="formInline.simIccicd"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item :label="$t('TerminalFile.pastDue')">
                    <el-select
                      v-model="formInline.typeId"
                      :placeholder="$t('common.all')"
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in pastList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                  <el-form-item :label="$t('TerminalFile.deliveryTime')">
                    <el-date-picker
                      v-model="formInline.factoryDate"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.search.dateSearch')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  type="text"
                  @click="refreshTerminal"
                  >{{$t('common.btn.refresh')}}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editTerminal"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button
                  type="text"
                  :disabled="abandonedDisabled"
                  @click="abandonedTerminal"
                  >{{ $t("SIMFile.abandoned") }}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteTerminal"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button type="text" @click="addTerminal">{{$t('common.btn.add')}}</el-button>
                <el-button type="text" @click="BulkImport">{{$t('common.btn.batchUpload')}}</el-button>
                <el-button type="text" @click="downTerminal">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="terminalId"
            :label="$t('common.terminalId')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.terminalId"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="typeId"
            :label="$t('OTAManagement.typeIdStr')+':'"
            :label-width="formLabelWidth"
          >
            <el-select v-model="form.typeId" :placeholder="$t('common.all')" size="small">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.terminalType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('TerminalFile.form.pushState')"
            :label-width="formLabelWidth"
            prop="pushState"
          >
            <el-select v-model="form.pushState">
              <el-option :label="$t('TerminalFile.unPush')" value="0"></el-option>
              <el-option :label="$t('TopBar.push')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="simIccicd"
            :label="$t('TerminalFile.simIccicd')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.simIccicd"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="deliveryTime"
            :label="$t('TerminalFile.deliveryTime')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.search.dateSearch')"
              v-model="form.deliveryTime"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeAbandonedDia"
        class="addDialong"
        :title="this.$t('SIMFile.abandoned')"
        :visible.sync="dialogAbandonedFormVisible"
        :close-on-click-modal="false"
      >
        <el-form ref="abandonedForm" :model="abandonedForm">
          <el-form-item
              prop="isAbandonSim"
              :label="$t('SIMFile.SIMCardScrapping')"
              :label-width="formLabelWidth"
              style="width: 100%"
            >
              <el-checkbox v-model="abandonedForm.isAbandonSim"></el-checkbox>
            </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('common.remark') + ':'"
            :label-width="formLabelWidth"
            class="remarkStyle"
          >
            <el-input
              type="textarea"
              :rows="2"
              size="small"
              v-model="abandonedForm.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="abandonedCancle('abandonedForm')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitAbandonedForm('abandonedForm')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeBatchDia"
        :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible"
        class="batchDialong"
        :close-on-click-modal="false"
      >
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()"
            >{{$t('common.btn.downloadModelFile')}}</el-button
          >
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{$t('common.btn.clickUploadFile')}}</div>
          <input @change="uploadFile()" id="uploadDom" type="file" style="display: none;" />
          <el-button type="primary" size="small" @click="triggerFileUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del"
            >{{$t('common.btn.cancel')}}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TerminalFile from "./TerminalFile.js";
export default TerminalFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
// /deep/.el-table--border th.el-table__cell.gutter:last-of-type {
//   width: 0;
//   display: none;
// }
</style>
